import { ErrorResponse } from '../../types';
import { LeaseCarDataResponse, LeaseCarDataResponseOccasion } from '../../types/leaseCarData';
import fetchFromKong from '../fetchFromKong';

export const fetchLeaseCarData = async (
	carId: string
): Promise<LeaseCarDataResponse | LeaseCarDataResponseOccasion> => {
	const response = await fetchFromKong(`privatelease/v1/leaseplan/leasecars/${carId}`);
	if (!response.ok) {
		return Promise.reject({
			title: response.statusText,
			statusCode: response.status,
		} as ErrorResponse);
	}

	return response.json();
};
